/**
 * The popup content placement
 */
export enum PopupPlacement {
  /**
   * The top placement
   */
  Top = 'top',

  /**
   * The bottom placement
   */
  Bottom = 'bottom',

  /**
   * The left placement
   */
  Left = 'left',

  /**
   * The right placement
   */
  Right = 'right',
}
